import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { MediaInputService } from '../services/media-input/media-input.service';
import { Observable, map, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MediaInputGuard implements CanActivate {
  constructor(
    private readonly mediaInputService: MediaInputService,
    private readonly router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    return this.mediaInputService.mediaConfiguration$.pipe(
      take(1),
      map((mediaConfiguration) => {
        if (mediaConfiguration === null) {
          // If no media configuration is set, redirect to media-input
          this.router.navigate(['/media-input']);
          return false;
        }
        // If media configuration is set, allow access to the route
        return true;
      }),
    );
  }
}
